import { EnvDTO, GameDTO, GameEventDTO, UserDTO } from '@envclient/envcore';

const SET_GAME_USER_LIST = 'SET_GAME_USER_LIST';
const JOIN_GAME = 'JOIN_GAME';
const LEAVE_GAME = 'LEAVE_GAME';
const UPDATE_GAME = 'UPDATE_GAME';
const UPDATE_ENV = 'UPDATE_ENV';
const GAME_EVENT = 'GAME_EVENT';
const GAME_EVENT_CONSUME = 'GAME_EVENT_CONSUME';

export { SET_GAME_USER_LIST, JOIN_GAME, LEAVE_GAME, UPDATE_GAME, UPDATE_ENV, GAME_EVENT, GAME_EVENT_CONSUME };

export const setGameUserList = (userList: UserDTO[]) => ({ type: SET_GAME_USER_LIST, userList });
export const leaveGame = (user: UserDTO) => ({ type: LEAVE_GAME, user });
export const joinGame = (user: UserDTO) => ({ type: JOIN_GAME, user });
export const updateGame = (game: GameDTO) => ({ type: UPDATE_GAME, game });
export const updateEnv = (env: EnvDTO) => ({ type: UPDATE_ENV, env });
export const gameEvent = (event: GameEventDTO) => ({ type: GAME_EVENT, event });
export const consumeGameEvent = (event: GameEventDTO) => ({ type: GAME_EVENT_CONSUME, event });
